/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
  uid         : 0,          // From Auth
  displayName : "John Doe", // From Auth
  about       : "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
  // photoURL    : require("@/assets/images/portrait/small/avatar-s-11.jpg"), // From Auth
  status      : "online",
  userRole    : "admin"
}

const userInfoLocalStorage = JSON.parse(localStorage.getItem("userInfo")) || {}

// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
const getUserInfo = () => {
  let userInfo = {}

  // Update property in user
  Object.keys(userDefaults).forEach((key) => {
    // If property is defined in localStorage => Use that
    userInfo[key] = userInfoLocalStorage[key] ?  userInfoLocalStorage[key] : userDefaults[key]
  })

  // Include properties from localStorage
  Object.keys(userInfoLocalStorage).forEach((key) => {
    if(userInfo[key] == undefined && userInfoLocalStorage[key] != null) userInfo[key] = userInfoLocalStorage[key]
  })

  return userInfo
}


// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
  var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  var mq = function(query) {
      return window.matchMedia(query).matches;
  }

  if (('ontouchstart' in window) || window.DocumentTouch) {
      return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
}


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
    AppActiveUser           : getUserInfo(),
    bodyOverlay             : false,
    isVerticalNavMenuActive : true,
    is_touch_device         : is_touch_device(),
    mainLayoutType          : themeConfig.mainLayoutType || "vertical",
    navbarSearchAndPinList  : navbarSearchAndPinList,
    reduceButton            : themeConfig.sidebarCollapsed,
    verticalNavMenuWidth    : "default",
    verticalNavMenuItemsMin : false,
    scrollY                 : 0,
    starredPages            : navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
    theme                   : themeConfig.theme || "light",
    themePrimaryColor       : colors.primary,

    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null,

    // Auth
  token: null,
  authdb: null,
  userRole: null,
  dburl:null,
  comid:null,

  // Grids
  cusgrid: null,
  custgroupsgrid: null,
  protypesgrid: null,
  transmodesgrid: null,
  usersgrid: null,
  usappsgrid: null,
  inbordersgrid: null,
  inbdetailsgrid: null,
  vendorsgrid:null,
  posgrid:null,
  producttypesgrid:null,
  productsgrid:null,
  locationsgrid:null,
  blocksgrid:null,
  invoicesgrid:null,
  posstate:null,
  invoicesstate:null,
  slabsgrid:null,
  slabsstate:null,
  blockscutgrid:null,
  blockscutitemsgrid:null,
  blockscutstate:null,
  blockscutitemsstate:null,
  slabscutgrid:null,
  slabscutstate:null,
  slabscutitemsgrid:null,
  slabscutitemsstate:null,
  slabsfinalsgrid:null,
  blockstransgrid:null,
  slabstransgrid:null,
  slabsfinalstransgrid:null,
  modesgrid:null,
  termsgrid:null,
  portsgrid:null,
  countrysgrid:null,
  finaccsgrid:null,
  finaccsubsgrid:null,
  companystypesgrid:null,
  companysgrid:null,
  banksgrid:null,
  remarksgrid:null,
  assetsgrid:null,
  stocksgrid:null,
  posdepositsgrid:null,
  posdata:null,
  posdatadel:null,
  remarkdata:null,
  remarkdatadel:null,
  savestate:null,
  inboundConfirm:null,
  posselected:null,
  itemlist:null,
  sumstate:null,
  hotPoitemsHide:null,
  selectState:null,
  m3_amount_exc:null,
  m3_cancel:null,
  m3_amount_remain:null,
  m3_rr:null,
  nblockname:null,
  nbrunning:null,
  chkdup:null,
  sentblock:null,
  sentslab:null,
  slabsfinalshow:null,
  posdatadelstate:null,
  posdatadelstate2:null,
  reportgrid:null,


  // Input Params
  minproduct:10,

  // Languages
  Homebar: 'HHH',
  chlang: 'th',

  //POS
  posinfor : {
    pos_number:"PO-1234",
  },

  //Pocredit
  poscreditinfor : {
    pos_number:"PO-1234",
  },

  //Blockcut
  blockscutinfor : {
    blocks_code:"PO-1234",
  },

  //Slabscut
  slabscutinfor : {
    slabs_code:"PO-1234",
  },

}

export default state
